import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const ProductAdd: React.FC = () => {
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);
  const [toast, setToast] = useState<{ message: string; type: 'success' | 'error' } | null>(null);
  const [formData, setFormData] = useState({
    name: '',
    price: '',
    stock: '0',
    description: '',
    status: 'active',
    is_featured: false,
    category_id: '1'
  });
  const [imageFile, setImageFile] = useState<File | null>(null);
  const [imagePreview, setImagePreview] = useState<string>('');

  // ── نمایش Toast ──────────────────────────────────────────
  const showToast = (message: string, type: 'success' | 'error') => {
    setToast({ message, type });
    setTimeout(() => setToast(null), 4000);
  };

  // ── آپلود تصویر ──────────────────────────────────────────
  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setImageFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result as string);
      };
      reader.readAsDataURL(file);
    }
  };

  // ── آپلود تصویر روی سرور ──────────────────────────────
  const uploadImage = async (file: File): Promise<string> => {
    const formData = new FormData();
    formData.append('image', file);

    try {
      const response = await fetch('https://fellfell.ir/api/upload.php', {
        method: 'POST',
        credentials: 'include',
        body: formData
      });

      const data = await response.json();
      if (data.success) {
        return data.filename; // برگرداندن نام فایل ذخیره شده
      } else {
        throw new Error(data.message || 'خطا در آپلود تصویر');
      }
    } catch (error) {
      throw new Error('خطا در آپلود تصویر: ' + (error as Error).message);
    }
  };

  // ── ثبت محصول ──────────────────────────────────────────
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // ── اعتبارسنجی ──────────────────────────────────────
    if (!formData.name || !formData.price) {
      showToast('نام و قیمت محصول الزامی است', 'error');
      return;
    }

    setSaving(true);

    try {
      // ── ۱. آپلود تصویر (اگر انتخاب شده) ──────────────
      let imageName = '';
      if (imageFile) {
        try {
          imageName = await uploadImage(imageFile);
        } catch (uploadError) {
          showToast((uploadError as Error).message, 'error');
          setSaving(false);
          return;
        }
      }

      // ── ۲. ثبت محصول در دیتابیس ──────────────────────
      const payload = {
        title: formData.name,
        name: formData.name,
        price: parseFloat(formData.price),
        stock: parseInt(formData.stock) || 0,
        description: formData.description,
        status: formData.status,
        is_featured: formData.is_featured ? 1 : 0,
        is_special: formData.is_featured ? 1 : 0,
        image: imageName || null,
        category_id: parseInt(formData.category_id) || 1
      };

      console.log('📤 ارسال داده:', payload);

      const response = await fetch('https://fellfell.ir/api/products.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(payload)
      });

      const data = await response.json();
      console.log('📨 پاسخ:', data);

      if (data.success) {
        showToast('✅ محصول با موفقیت اضافه شد', 'success');
        setTimeout(() => {
          navigate('/admin/products');
        }, 1500);
      } else {
        showToast('❌ خطا در ذخیره محصول: ' + (data.message || 'خطای نامشخص'), 'error');
      }
    } catch (err: any) {
      console.error('❌ خطا:', err);
      showToast('❌ خطا در ذخیره محصول: ' + err.message, 'error');
    }

    setSaving(false);
  };

  return (
    <div style={{ direction: 'rtl', padding: '20px', maxWidth: '700px', margin: '0 auto' }}>
      {/* ── Toast ────────────────────────────────────────── */}
      {toast && (
        <div style={{
          position: 'fixed',
          top: '20px',
          left: '50%',
          transform: 'translateX(-50%)',
          padding: '14px 28px',
          borderRadius: '12px',
          fontSize: '15px',
          zIndex: 9999,
          background: toast.type === 'success' ? '#2e7d32' : '#c62828',
          color: '#fff',
          boxShadow: '0 6px 25px rgba(0,0,0,0.25)',
          animation: 'slideDown 0.3s ease-out'
        }}>
          {toast.message}
        </div>
      )}

      {/* ── هدر ──────────────────────────────────────────── */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '25px' }}>
        <h1 style={{ color: '#1e3a1e', fontSize: '24px' }}>➕ افزودن محصول جدید</h1>
        <Link to="/admin/products" style={{
          padding: '8px 16px',
          background: '#e0e0e0',
          color: '#333',
          textDecoration: 'none',
          borderRadius: '8px',
          fontSize: '14px'
        }}>
          ← بازگشت به لیست محصولات
        </Link>
      </div>

      {/* ── فرم ──────────────────────────────────────────── */}
      <form onSubmit={handleSubmit} style={{ background: '#fff', padding: '30px', borderRadius: '16px', boxShadow: '0 2px 10px rgba(0,0,0,0.06)' }}>
        {/* نام */}
        <div style={{ marginBottom: '18px' }}>
          <label style={{ display: 'block', fontWeight: '600', marginBottom: '6px', fontSize: '14px' }}>
            نام محصول <span style={{ color: '#d32f2f' }}>*</span>
          </label>
          <input
            type="text"
            value={formData.name}
            onChange={e => setFormData({ ...formData, name: e.target.value })}
            style={{ width: '100%', padding: '11px 14px', borderRadius: '10px', border: '2px solid #ddd', fontSize: '15px' }}
            placeholder="مثلاً: گوجه فرنگی ارگانیک"
            required
          />
        </div>

        {/* قیمت و موجودی */}
        <div style={{ display: 'flex', gap: '15px', marginBottom: '18px' }}>
          <div style={{ flex: 1 }}>
            <label style={{ display: 'block', fontWeight: '600', marginBottom: '6px', fontSize: '14px' }}>
              قیمت (تومان) <span style={{ color: '#d32f2f' }}>*</span>
            </label>
            <input
              type="number"
              value={formData.price}
              onChange={e => setFormData({ ...formData, price: e.target.value })}
              style={{ width: '100%', padding: '11px 14px', borderRadius: '10px', border: '2px solid #ddd', fontSize: '15px' }}
              placeholder="مثلاً: 25000"
              required
            />
          </div>
          <div style={{ flex: 1 }}>
            <label style={{ display: 'block', fontWeight: '600', marginBottom: '6px', fontSize: '14px' }}>
              موجودی
            </label>
            <input
              type="number"
              value={formData.stock}
              onChange={e => setFormData({ ...formData, stock: e.target.value })}
              style={{ width: '100%', padding: '11px 14px', borderRadius: '10px', border: '2px solid #ddd', fontSize: '15px' }}
              placeholder="مثلاً: 100"
            />
          </div>
        </div>

        {/* دسته‌بندی و وضعیت */}
        <div style={{ display: 'flex', gap: '15px', marginBottom: '18px' }}>
          <div style={{ flex: 1 }}>
            <label style={{ display: 'block', fontWeight: '600', marginBottom: '6px', fontSize: '14px' }}>
              دسته‌بندی
            </label>
            <select
              value={formData.category_id}
              onChange={e => setFormData({ ...formData, category_id: e.target.value })}
              style={{ width: '100%', padding: '11px 14px', borderRadius: '10px', border: '2px solid #ddd', fontSize: '15px' }}
            >
              <option value="1">سبزیجات</option>
              <option value="2">میوه‌ها</option>
              <option value="3">صیفی‌جات</option>
              <option value="4">حبوبات</option>
            </select>
			// در بخش دسته‌بندی، این گزینه‌ها را اضافه کنید:

<select
  value={formData.category_id}
  onChange={e => setFormData({ ...formData, category_id: e.target.value })}
  style={{ width: '100%', padding: '11px 14px', borderRadius: '10px', border: '2px solid #ddd', fontSize: '15px' }}
>
  <option value="1">🌱 بذر و نشا</option>
  <option value="2">🧪 کود</option>
  <option value="3">💊 سم</option>
</select>
          </div>
          <div style={{ flex: 1 }}>
            <label style={{ display: 'block', fontWeight: '600', marginBottom: '6px', fontSize: '14px' }}>
              وضعیت
            </label>
            <select
              value={formData.status}
              onChange={e => setFormData({ ...formData, status: e.target.value })}
              style={{ width: '100%', padding: '11px 14px', borderRadius: '10px', border: '2px solid #ddd', fontSize: '15px' }}
            >
              <option value="active">فعال (منتشر شده)</option>
              <option value="inactive">غیرفعال (پیش‌نویس)</option>
            </select>
          </div>
        </div>

        {/* توضیحات */}
        <div style={{ marginBottom: '18px' }}>
          <label style={{ display: 'block', fontWeight: '600', marginBottom: '6px', fontSize: '14px' }}>
            توضیحات
          </label>
          <textarea
            value={formData.description}
            onChange={e => setFormData({ ...formData, description: e.target.value })}
            rows={4}
            style={{ width: '100%', padding: '11px 14px', borderRadius: '10px', border: '2px solid #ddd', fontSize: '15px', resize: 'vertical' }}
            placeholder="توضیحات کامل محصول..."
          />
        </div>

        {/* آپلود تصویر */}
        <div style={{ marginBottom: '18px' }}>
          <label style={{ display: 'block', fontWeight: '600', marginBottom: '6px', fontSize: '14px' }}>
            تصویر محصول
          </label>
          <div style={{
            border: '2px dashed #ddd',
            borderRadius: '10px',
            padding: '20px',
            textAlign: 'center',
            cursor: 'pointer',
            transition: 'border-color 0.2s',
            background: '#fafafa'
          }}
          onDragOver={(e) => { e.preventDefault(); e.currentTarget.style.borderColor = '#2e7d32'; }}
          onDragLeave={(e) => { e.currentTarget.style.borderColor = '#ddd'; }}
          onDrop={(e) => {
            e.preventDefault();
            const file = e.dataTransfer.files[0];
            if (file) {
              setImageFile(file);
              const reader = new FileReader();
              reader.onloadend = () => setImagePreview(reader.result as string);
              reader.readAsDataURL(file);
            }
          }}
          >
            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              style={{ display: 'none' }}
              id="image-upload"
            />
            <label htmlFor="image-upload" style={{ cursor: 'pointer', display: 'block' }}>
              {imagePreview ? (
                <img src={imagePreview} alt="پیش‌نمایش" style={{ maxWidth: '200px', maxHeight: '200px', borderRadius: '8px' }} />
              ) : (
                <>
                  <div style={{ fontSize: '40px', marginBottom: '10px' }}>🖼️</div>
                  <p style={{ color: '#888' }}>برای آپلود تصویر کلیک کنید یا بکشید</p>
                  <p style={{ fontSize: '12px', color: '#aaa' }}>فرمت‌های مجاز: JPG, PNG, GIF</p>
                </>
              )}
            </label>
          </div>
          {imageFile && (
            <div style={{ marginTop: '8px', fontSize: '13px', color: '#555' }}>
              📎 {imageFile.name} ({(imageFile.size / 1024).toFixed(1)} KB)
              <button
                type="button"
                onClick={() => { setImageFile(null); setImagePreview(''); }}
                style={{ marginRight: '10px', background: 'none', border: 'none', color: '#c62828', cursor: 'pointer' }}
              >
                ❌ حذف
              </button>
            </div>
          )}
        </div>

        {/* ویژه */}
        <div style={{ marginBottom: '22px' }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', cursor: 'pointer' }}>
            <input
              type="checkbox"
              checked={formData.is_featured}
              onChange={e => setFormData({ ...formData, is_featured: e.target.checked })}
              style={{ width: '18px', height: '18px' }}
            />
            <span>🌟 محصول ویژه (نمایش در صفحه اصلی)</span>
          </label>
        </div>

        {/* دکمه‌ها */}
        <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end', borderTop: '1px solid #eee', paddingTop: '20px' }}>
          <Link to="/admin/products" style={{
            padding: '12px 24px',
            background: '#e0e0e0',
            color: '#333',
            textDecoration: 'none',
            borderRadius: '10px',
            fontSize: '15px',
            fontWeight: '500'
          }}>
            انصراف
          </Link>
          <button
            type="submit"
            disabled={saving}
            style={{
              padding: '12px 30px',
              background: '#2e7d32',
              color: '#fff',
              border: 'none',
              borderRadius: '10px',
              fontSize: '15px',
              fontWeight: '600',
              cursor: 'pointer',
              opacity: saving ? 0.6 : 1
            }}
          >
            {saving ? '⏳ در حال ذخیره...' : '➕ افزودن محصول'}
          </button>
        </div>
      </form>

      <style>{`
        @keyframes slideDown {
          from { opacity: 0; transform: translateX(-50%) translateY(-20px); }
          to { opacity: 1; transform: translateX(-50%) translateY(0); }
        }
      `}</style>
    </div>
  );
};

export default ProductAdd;